<template>
  <div>
    <!-- Header -->
    <!-- <div
      class="header pb-9"
      style="background-image: url(img/theme/hero-bg.jpg)"
    >
      <b-nav align="right" class="mb-3" style="background-color: #ffffff7a">
        <b-nav-item to="/" class="text-primary mr-3"
          ><i class="far fa-home"></i> Inicio</b-nav-item
        >
      </b-nav>
    </div> -->
    <!-- Page content -->
    <b-container>
      <b-row class="justify-content-center">
        <b-col
          lg="5"
          md="7"
          style="min-height: 100dvh"
          class="d-flex align-items-center"
        >
          <div style="min-width: 100%">
            <b-card
              no-body
              class="d-block border-0 mb-0"
              style="min-width: 100%"
            >
              <!-- <b-card-header class="bg-transparent pb-5"  >
              <div class="text-muted text-center mt-2 mb-3"><small>Sign in with</small></div>
              <div class="btn-wrapper text-center">
                <a href="#" class="btn btn-neutral btn-icon">
                  <span class="btn-inner--icon"><img src="img/icons/common/github.svg"></span>
                  <span class="btn-inner--text">Github</span>
                </a>
                <a href="#" class="btn btn-neutral btn-icon">
                  <span class="btn-inner--icon"><img src="img/icons/common/google.svg"></span>
                  <span class="btn-inner--text">Google</span>
                </a>
              </div>
            </b-card-header>-->
              <b-card-body class="px-lg-5 py-lg-5">
                <b-img fluid src="img/brand/nuevo_logo.svg"></b-img>
                <div class="text-center text-muted mb-4">
                  <small>INICIAR SESION</small>
                </div>
                <b-alert
                  :show="Boolean(errors)"
                  variant="danger"
                  @dismiss-count-down="false"
                >
                  <span v-for="(e, k) in errors" :key="k">{{ e }}</span>
                </b-alert>
                <validation-observer
                  v-slot="{ handleSubmit }"
                  ref="formValidator"
                >
                  <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                    <base-input
                      alternative
                      class="mb-3"
                      name="email"
                      :rules="{ required: true, email: false }"
                      prepend-icon="fas fa-user"
                      placeholder="Usuario"
                      v-model="model.email"
                    ></base-input>

                    <base-input
                      alternative
                      class="mb-3"
                      name="password"
                      :rules="{ required: true, min: 4 }"
                      prepend-icon="ni ni-lock-circle-open"
                      type="password"
                      placeholder="Contraseña"
                      autocomplete="on"
                      v-model="model.password"
                    ></base-input>

                    <b-form-checkbox v-model="model.rememberMe"
                      >Remember me</b-form-checkbox
                    >
                    <div class="text-center">
                      <base-button
                        type="primary"
                        native-type="submit"
                        class="my-4"
                        >Ingresar</base-button
                      >
                    </div>
                  </b-form>
                </validation-observer>
              </b-card-body>
            </b-card>
            <b-row class="mt-3">
              <b-col cols="6">
                <!-- <router-link to="/dashboard" class="text-dark">
                  <small>Contraseña perdida ?</small>
                </router-link> -->
              </b-col>
              <b-col cols="6" class="text-right">
                <!-- <router-link to="/register" class="text-light"><small>Create new account</small></router-link> -->
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      working: false,
      errors: null,
      model: {
        email: "",
        password: "",
        rememberMe: false,
      },
    };
  },
  methods: {
    onSubmit() {
      this.errors = null;
      this.working = true;
      // this will be called only after form is valid. You can do api call here to login
      this.$api
        .post("/users/login", this.model)
        .then((res) => {
          this.$store.commit("setSession", res.data);
          this.$router.push("dashboard");
        })
        .catch((e) => {
          if (e.response) {
            this.errors = e.response.data.errors;
          }
        })
        .then(() => {
          this.working = false;
        });
    },
  },
};
</script>
